<script>
  import { onMount } from 'svelte';
  import MainCipher from './components/MainCipher.svelte';
  import Menu from './components/Menu.svelte';
  import { CipherStore } from './store'
  
  let cipherLib = []
  CipherStore.subscribe((value) => {
    cipherLib = value
    console.log(cipherLib[0]);
  })

  let OpenedCipherId = 'CaeserCipher'
  $: OpenedCipher = cipherLib.find((cipher) => cipher.id === OpenedCipherId);
  $: console.log(OpenedCipher);

  function changeCipher(cipherId) {
    OpenedCipherId = cipherId
  }
</script>
  {#key OpenedCipherId}
    <MainCipher Cipher={OpenedCipher}/>
  {/key}
  <Menu currentCipher = {OpenedCipher.id} on:changeCipher = {(e) => changeCipher(e.detail)}/>
<style>


</style>